import type { Request } from '@/types/Request';

export const getIpFromReq = (req: Request): string | undefined => {
  // Example Headers From Cloudflare and K8s Load Balancer
  //  cf-ipCountry --> US
  //  cf-connecting-ip --> 66.xx.xx.x
  //  x-original-forwarded-for --> 66.xx.xx.x
  //  x-google-real-ip --> 66.xx.xx.x
  //  x-forwarded-for --> 66.xx.xx.x
  //  x-real-ip --> 66.xx.xx.x
  // cf-connection-ip is the same as true-client-ip, but the latter is
  // for enterprise plans only. It's here as fallback, but not confirmed
  // that we have it enabled. x-forwarded-for could be a list of IPs if
  // the requests went through multiple proxies - the first IP should
  // match cf-connecting-ip, so, again, it's only being used as another
  // fallback. Similar with x-original.
  // See more: https://developers.cloudflare.com/fundamentals/get-started/reference/http-request-headers/#true-client-ip-enterprise-plan-only

  const connectingIP =
    req.headers?.['cf-connecting-ip'] ||
    req.headers?.['true-client-ip'] ||
    req.headers?.['x-forwarded-for'] ||
    req.headers?.['x-original-forwarded-for'];

  return connectingIP || req.ip;
};
